export default __webpack_public_path__ + "static/media/404.c6805c5e.svg";